import initialState from './initialState';
import { reducer as loadExternalApisReducer } from './loadExternalApis';
import { reducer as deleteExternalApiReducer } from './deleteExternalApi';
import { reducer as createExternalApiReducer } from './createExternalApi';
import { reducer as updateExternalApiReducer } from './updateExternalApi';
import { reducer as loadExternalApiReducer } from './loadExternalApi';
import { reducer as loadCollectionsReducer } from './loadCollections';
import { reducer as sendMockDataRequestReducer } from './sendMockDataRequest';
import { reducer as showCollectionMappingReducer } from './showCollectionMapping';
import { reducer as cloneExternalApiReducer } from './cloneExternalApi';
import { reducer as loadExternalDatabaseReducer } from './loadExternalDatabase';
import { reducer as updateExternalApiTypeReducer } from './updateExternalApiType';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';

const reducers = [
  loadExternalApisReducer,
  deleteExternalApiReducer,
  createExternalApiReducer,
  updateExternalApiReducer,
  loadExternalApiReducer,
  loadCollectionsReducer,
  sendMockDataRequestReducer,
  showCollectionMappingReducer,
  cloneExternalApiReducer,
  loadExternalDatabaseReducer,
  updateExternalApiTypeReducer,
  getPermissionFlagsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
